var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'tw-px-8 tw-py-5 tw-overflow-y-auto tw-h-full',
    _vm.isMobile ? 'tw-w-screen' : '' ]},[(_vm._pyfalsey(_vm.loggingMessage))?_c('div',[_c('span',{staticClass:"tw-font-bold"},[_vm._v(_vm._s(_vm.runningMessage))]),_c('LoadingEllipses')],1):_c('MarkdownDisplay',{attrs:{"markdown":_vm.loggingMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }